import { DeviceSettings } from '../../config/DeviceSettings';

import { zoneActivityCapabilities } from '../../config/zoneActivityCapabilities';

import { theme } from '../../theme/theme';

import { ZoneActivityPulse } from '../zone/ZoneActivityPulse';
import { Icon } from '../common/Icon';

import { iconWarningCircle } from '../../theme/icons/interface/warning-circle/warning-circle';

export function IndicatorAlarmSpecificStatic({ device, capabilityId }) {
  const isZoneActivityCapability = zoneActivityCapabilities.has(capabilityId);

  if (!device.settings[DeviceSettings.ZoneActivityDisabled] && isZoneActivityCapability) {
    return <ZoneActivityPulse />;
  }

  return <Icon display="block" url={iconWarningCircle} color={theme.color.yellow} size="20px" />;
}
